import { SESSION_EXPIRED_STORAGE_KEY } from '#shared/constants/auth';
import {
  APP_ACCESS_REQUIRED_SCOPES,
  LOGIN_MISSING_PERMISSIONS_REASON,
  hasRequiredScopes,
} from '#shared/constants/permissions';

/**
 * Middleware global de autenticación
 *
 * Protege las rutas /admin/* y redirige a usuarios autenticados
 * fuera de las páginas públicas.
 */

export default defineNuxtRouteMiddleware(async (to, from) => {
  // useUserSession es proporcionado por nuxt-auth-utils
  const { loggedIn, user } = useUserSession();

  const isAdminRoute = to.path.startsWith('/admin');
  const isAuthRoute = to.path.startsWith('/auth');

  // Si es una ruta de autenticación, no hacer nada (dejar que Nitro lo gestione)
  if (isAuthRoute) {
    return;
  }

  // No está autenticado y es una ruta protegida -> redirigir a login
  if (!loggedIn.value && isAdminRoute) {
    // Si venía de una ruta /admin, la sesión caducó mientras usaba la app
    if (import.meta.client && from.path.startsWith('/admin')) {
      sessionStorage.setItem(SESSION_EXPIRED_STORAGE_KEY, '1');
    }
    return navigateTo('/auth/login', { external: true });
  }

  // Está autenticado pero no tiene permisos para acceder a la app admin
  if (loggedIn.value && isAdminRoute && !hasRequiredScopes(user.value?.scopes, APP_ACCESS_REQUIRED_SCOPES)) {
    return navigateTo({
      path: '/login',
      query: { reason: LOGIN_MISSING_PERMISSIONS_REASON },
    });
  }

  // Está autenticado y es la página de inicio -> redirigir a /admin
  if (loggedIn.value && to.path === '/') {
    return navigateTo('/admin');
  }
});
